<template>
  <div class="review-hearing-test">
    <HeroBanner
        :background-image="bannerImage"
        title="청력검사 후기"
        sub-title="다비치 히어링 보청기 고객님들의 솔직하고 생생한 경험, <br>
        지역별, 연령별 내 이웃의 후기를 <br>
        직접 확인해보세요."
    />
    <ReviewList
      :reviews="reviews"
      :show-more-button="hasMore"
      :loading="loading"
      @search="handleSearch"
      @review-click="handleReviewClick"
      @load-more="loadMoreReviews"
    />
  </div>
</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import ReviewList from "@/components/ReviewList.vue";
import reviewListMixin from '@/mixins/reviewListMixin';
import { fetchHearingTestReview } from '@/api';
import bannerBg from '@/assets/images/heros/04-top-img.png';
import bannerBg2 from '@/assets/images/heros/04-top-img@2x.png';

export default {
  name: 'ReviewHearingTest',
  components: {
    HeroBanner,
    ReviewList
  },
  mixins: [reviewListMixin],
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
      reviewType: 'hearing-test'
    };
  },
  methods: {
    fetchAPI(params) {
      return fetchHearingTestReview(params);
    }
  }
};
</script>

<style scoped lang="scss">
.review-hearing-test {
  width: 100%;
  min-height: 55px;
}
</style>
